import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../css/home.css";

const Home = () => {
  const skills = [
    {
      name: "HTML",
      link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
      angle: 0,
      bg: "rgba(249, 115, 22, 0.18)",
      border: "rgba(249, 115, 22, 0.45)",
      color: "#c2410c",
    },
    {
      name: "CSS",
      link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
      angle: 30,
      bg: "rgba(59, 130, 246, 0.16)",
      border: "rgba(59, 130, 246, 0.4)",
      color: "#1d4ed8",
    },
    {
      name: "JavaScript",
      link: "https://javascript.info/",
      angle: 60,
      bg: "rgba(250, 204, 21, 0.2)",
      border: "rgba(234, 179, 8, 0.45)",
      color: "#a16207",
    },
    // {
    //   name: "Node Js",
    //   link: "https://nodejs.org/docs/latest/api/",
    //   angle: 90,
    //   bg: "rgba(34, 197, 94, 0.16)",
    //   border: "rgba(34, 197, 94, 0.42)",
    //   color: "#15803d",
    // },
    // {
    //   name: "MongoDB",
    //   link: "https://www.mongodb.com/",
    //   angle: 120,
    //   bg: "rgba(16, 185, 129, 0.16)",
    //   border: "rgba(5, 150, 105, 0.4)",
    //   color: "#047857",
    // },
    {
      name: "React Js",
      link: "https://react.dev/learn",
      angle: 150,
      bg: "rgba(34, 211, 238, 0.16)",
      border: "rgba(6, 182, 212, 0.4)",
      color: "#0f766e",
    },
    {
      name: "Redux",
      link: "https://redux.js.org/",
      angle: 180,
      bg: "rgba(168, 85, 247, 0.16)",
      border: "rgba(147, 51, 234, 0.4)",
      color: "#7e22ce",
    },
    {
      name: "Bootstrap",
      link: "https://getbootstrap.com/",
      angle: 210,
      bg: "rgba(139, 92, 246, 0.16)",
      border: "rgba(124, 58, 237, 0.4)",
      color: "#6d28d9",
    },
    {
      name: "Tailwind",
      link: "https://tailwindcss.com/docs/installation/using-vite",
      angle: 240,
      bg: "rgba(14, 165, 233, 0.16)",
      border: "rgba(2, 132, 199, 0.4)",
      color: "#0369a1",
    },
    {
      name: "GitHub",
      link: "https://github.com/",
      angle: 270,
      bg: "rgba(100, 116, 139, 0.16)",
      border: "rgba(71, 85, 105, 0.38)",
      color: "#334155",
    },
    {
      name: "Firebase",
      link: "https://firebase.google.com/",
      angle: 300,
      bg: "rgba(251, 191, 36, 0.2)",
      border: "rgba(245, 158, 11, 0.42)",
      color: "#b45309",
    },
  ];

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section id="home" className="home-section pt-32 md:pt-0">
      <div className="home-shell">
        <div data-aos="fade-right" className="home-copy-panel">
          <div className="home-copy-card">
            <div className="inline-flex rounded-full border border-white/10 bg-white/5 px-4 py-2 font-mono text-sm text-zinc-200 shadow-sm">
              React | JavaScript | Redux
            </div>
            <h1 className="mt-4 intro text-zinc-300">Hi I'm Bindu,</h1>

            <h2 className="w-full mt-5 text-3xl">
              Frontend Developer | Ready to Contribute
            </h2>

            <h1 className="home-intro-copy text-lg text-zinc-300">
              Hands-on experience through freelance projects, with a strong
              focus on responsive design and modern web technologies...{" "}
            </h1>
            <div className="flex flex-wrap justify-start items-center gap-10 mt-8">
              <a
                href="#projects"
                className=" inline-flex items-center justify-center min-w-[150px] px-6 py-3 
                            rounded-full  text-lg font-bold text-indigo-600 border border-indigo-600
                            transition-all duration-200 ease-in-out
                            hover:-translate-y-1 hover:bg-indigo-600 hover:text-white hover:shadow-md"
              >
                Projects
              </a>
              <a
                href="/Resume.pdf"
                target="_blank"
                rel="norefferer"
                className="text-indigo-600 text-lg font-medium underline underline-offset-4
                 transition-all duration-500  ease-in-out
                            hover:-translate-y-1  hover:shadow-md"
              >
                View Resume
              </a>
            </div>
          </div>
        </div>

        <div data-aos="fade-left" className="home-skills-panel">
          <div className="home-skills-card">
            <div className="flex justify-center items-center mt-10">
              <div className="tech-stack-orbit">
                {skills.map((skill, i) => {
                  const radius = 120;
                  const angle = (i / skills.length) * Math.PI * 2 - Math.PI / 2;
                  const x = radius * Math.cos(angle);
                  const y = radius * Math.sin(angle);

                  return (
                    <a
                      key={i}
                      href={skill.link}
                      target="_blank"
                      rel="noreferrer"
                      className="tech-stack-skill"
                      style={{
                        top: `calc(50% + ${y}px)`,
                        left: `calc(50% + ${x}px)`,
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <span
                        className="tech-stack-skill-pill"
                        style={{
                          "--stack-bg": skill.bg,
                          "--stack-border": skill.border,
                          "--stack-color": skill.color,
                        }}
                      >
                        {skill.name}
                      </span>
                    </a>
                  );
                })}

                <div className="tech-stack-center">
                  <span className="tech-stack-center-label">Tech Stack</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
